import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import './SummaryTab.css';

const SummaryTab = ({ video }) => {
  if (!video.summary) {
    return (
      <div className="summary-container">
        <div className="no-content">
          <p>No summary available for this video yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="summary-container">
      <ReactMarkdown
        remarkPlugins={[remarkMath]}
        rehypePlugins={[rehypeKatex]}
        components={{
          h1: ({ children }) => <h1 className="summary-h1">{children}</h1>,
          h2: ({ children }) => <h2 className="summary-h2">{children}</h2>,
          h3: ({ children }) => <h3 className="summary-h3">{children}</h3>,
          p: ({ children }) => <p className="summary-p">{children}</p>,
          ul: ({ children }) => <ul className="summary-ul">{children}</ul>,
          ol: ({ children }) => <ol className="summary-ol">{children}</ol>,
          li: ({ children }) => <li className="summary-li">{children}</li>,
          blockquote: ({ children }) => <blockquote className="summary-blockquote">{children}</blockquote>,
          code: ({ inline, className, children, ...props }) => {
            const match = /language-(\w+)/.exec(className || '');
            return !inline && match ? (
              <SyntaxHighlighter
                style={vscDarkPlus}
                language={match[1]}
                PreTag="div"
                {...props}
              >
                {String(children).replace(/\n$/, '')}
              </SyntaxHighlighter>
            ) : (
              <code className="summary-inline-code" {...props}>
                {children}
              </code>
            );
          }
        }}
      >
        {video.summary}
      </ReactMarkdown>
    </div>
  );
};

export default SummaryTab; 